import { AfterViewInit, Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { InputWrapperComponent } from '../input-wrapper/input-wrapper.component';

@Component({
  selector: 'psc-google-autocomplete',
  templateUrl: './google-autocomplete.component.html'
})
export class GoogleAutocompleteComponent extends InputWrapperComponent<string> implements AfterViewInit {
  @Input() adressType: string = 'address';
  @Input() countries: string[] = ['HR', 'BA'];
  @Output() setAddress: EventEmitter<google.maps.places.PlaceResult> = new EventEmitter();
  @ViewChild('addresstext') addresstext: any;

  ngAfterViewInit() {
    this.getPlaceAutocomplete();
  }

  private getPlaceAutocomplete() {
    const autocomplete = new google.maps.places.Autocomplete(this.addresstext.nativeElement,
      {
        componentRestrictions: { country: this.countries },
        types: [this.adressType]  // 'establishment' / 'address' / 'geocode'
      });
    google.maps.event.addListener(autocomplete, 'place_changed', () => {
      const place = autocomplete.getPlace();
      this.invokeEvent(place);
    });
  }

  invokeEvent(place: google.maps.places.PlaceResult) {
    this.setAddress.emit(place);
  }

}
